import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  setYardSummaryModalIsOpen,
  setIsYardLegendsModalOpen
} from "../../store/yardSlice";
import Button from "../Reusables/Button/Button";
import Arrow from "../../assets/icons/arrow.png";
import LeftArrow from "../../assets/icons/leftArrow.png";
import LeftArrowTail from "../../assets/icons/arrowLeft.png";
import InfoSmall from "../../assets/icons/infoSmall.png";
import { AppContext } from "../../Context/Context";
import "../../assets/css/Header/header.css";
import { setNavQualityHeatmapIsEnabled } from "../../store/navHeatmapSlice";
import {
  setTimeMachineModeIsEnabled,
  setTimeMachineState
} from "../../store/oldTimeMachineSlice";
import { setTimeMachineV2ModeIsEnabled } from "../../store/newTimeMachineSlice";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { plantCode } = useParams();
  const {
    plantConfig,
    timeMachineTimeFrames,
    setTimeMachineTimeFrames,
    timeRangePopup,
    setTimeRangePopup,
    customizePopup,
    setCustomizePopup,
    setWarehouseModelIsOpen,
    layoutPopup,
    setLayoutPopup,
    showSaveDiscardLayout,
    customizeLayoutHandler,
    
  } = useContext(AppContext);

  const {
    navQualityHeatmapIsEnabled,
    navHeatmapTimeFrames,
    isLevel3ApiComplete
  } = useSelector((state) => state.navHeatmap);

  const { timeMachineModeIsEnabled } = useSelector(
    (state) => state.oldTimeMachine
  );

   const { timeMachineV2ModeIsEnabled } = useSelector(
     (state) => state.newTimeMachine
   );

  const inOldTimeMachinePage = pathname.includes("old-time-machine");

  const inNavHeatMapPage = pathname.includes("nav-quality-heatmap");

  const navigateToDashboard = () => {
    navigate(`/${plantCode}`);
  };

  //utilised for both of the time machines
  const exitTimeMachineMode = () => {
    dispatch(setTimeMachineModeIsEnabled(false));
    dispatch(setTimeMachineV2ModeIsEnabled(false));
    dispatch(setTimeMachineState(false));
    setTimeMachineTimeFrames({});
    navigateToDashboard();
  };

  const exitNavHeatMapPage = () => {
    dispatch(setNavQualityHeatmapIsEnabled(false));
    navigateToDashboard();
  };

  const openWarehouseModal = () => {
    setWarehouseModelIsOpen(true);
    document.body.classList.add("prevent-scroll");
  };

  const headingMap = {
    "yard-view": "Yard View",
    "allocated-view": "Allocated View",
    "time-machine": "Time Machine"
  };

  const RenderFeatureHeading = () => {
    if (
      timeMachineModeIsEnabled ||
      timeMachineV2ModeIsEnabled ||
      inOldTimeMachinePage
    ) {
      return (
        <div className="time-machine-header-topic">
          <img
            onClick={exitTimeMachineMode}
            src={LeftArrowTail}
            alt="left_arrow"
          />
          <h3>Time Machine</h3>
        </div>
      );
    } else if (navQualityHeatmapIsEnabled || inNavHeatMapPage) {
      return (
        <div className="time-machine-header-topic">
          <img
            onClick={exitNavHeatMapPage}
            src={LeftArrowTail}
            alt="left_arrow"
          />
          <h3>NavQuality Heatmap</h3>
          {isLevel3ApiComplete ? (
            <div className="level-loader">
              <div className="spinner"></div>
            </div>
          ) : null}
        </div>
      );
    } else {
      return (
        headingMap[pathname.split("/").at(-1)] && (
          <>
            <img
              onClick={() => navigate(`/${plantCode}`)}
              src={LeftArrowTail}
              alt="left_arrow"
              className="left-arrow"
            />
            <h3>{headingMap[pathname.split("/").at(-1)] ?? ""}</h3>
          </>
        )
      );
    }
  };

  const RenderTimeSelector = ({ timestamp }) => {
    const isEmpty = !timestamp || Object.keys(timestamp).length === 0;
    return (
      <div
        onClick={() => setTimeRangePopup(!timeRangePopup)}
        className="time-frame-displayer"
        style={{
          marginBottom:
            timeMachineModeIsEnabled || timeMachineV2ModeIsEnabled ? "16px" : 0
        }}
      >
        {isEmpty ? (
          <p>Click here to select Time Frame</p>
        ) : (
          <>
            <div className="from-date">
              {timestamp.fromDate} - {timestamp.fromTime}
            </div>
            to
            <div className="to-date">
              {timestamp.toDate} - {timestamp.toTime}
            </div>
          </>
        )}
      </div>
    );
  };

  const RenderTimeFrame = () => {
    if (timeMachineModeIsEnabled || inOldTimeMachinePage) {
      return <RenderTimeSelector timestamp={timeMachineTimeFrames} />;
    } else if (navQualityHeatmapIsEnabled || inNavHeatMapPage) {
      return <RenderTimeSelector timestamp={navHeatmapTimeFrames} />;
    }
  };

  const RenderActiveModule = () => {
    if (
      timeMachineModeIsEnabled ||
      navQualityHeatmapIsEnabled ||
      inOldTimeMachinePage ||
      inNavHeatMapPage
    ) {
      return <RenderTimeFrame />;
    } else {
      if (pathname.includes("yard-view")) {
        return (
          <>
            <Button
              placeholder="Legends"
              icon={InfoSmall}
              onClick={() => dispatch(setIsYardLegendsModalOpen(true))}
            />

            <Button
              placeholder="Yard Summary"
              btnClass="reverse-content"
              imgClass="reverse-content-img"
              icon={Arrow}
              onClick={() => dispatch(setYardSummaryModalIsOpen(true))}
            />
          </>
        );
      } else if (
        pathname.includes("allocated-view") ||
        timeMachineV2ModeIsEnabled
      ) {
        return null;
      } else {
        if (showSaveDiscardLayout) {
          return (
            <div className="options-section">
              <Button
                placeholder="Discard"
                btnClass="reverse-content customize-btn"
                imgClass="reverse-content-img"
                onClick={() => customizeLayoutHandler("discard")}
              />
              <Button
                placeholder="Save Layout"
                btnClass="reverse-content customize-btn selected"
                imgClass="reverse-content-img"
                onClick={() => customizeLayoutHandler("save")}
              />
            </div>
          );
        } else {
          return (
            <div className="options-section">
              <Button
                placeholder="Layout"
                icon={Arrow}
                btnClass="reverse-content customize-btn"
                imgClass="reverse-content-img"
                onClick={() => setLayoutPopup(!layoutPopup)}
              />
              <Button
                disabled={!plantConfig}
                placeholder="Customize"
                icon={Arrow}
                btnClass="reverse-content customize-btn"
                imgClass="reverse-content-img"
                onClick={() => setCustomizePopup(!customizePopup)}
              />
              <Button
                placeholder="Warehouse Info"
                icon={LeftArrow}
                btnClass="reverse-content customize-btn warehouse-btn"
                imgClass="reverse-content-img"
                onClick={() => openWarehouseModal()}
              />
            </div>
          );
        }
      }
    }
  };

  return (
    <div
      className="header-container"
      style={{
        justifyContent: <RenderFeatureHeading /> ? "space-between" : "flex-end"
      }}
    >
      {<RenderFeatureHeading /> && (
        <div className="title-section">{<RenderFeatureHeading />}</div>
      )}
      <div className="time-options-section">
        <RenderActiveModule />
      </div>
    </div>
  );
};

export default Header;
